/** Warren's ruling 2 (17 October 2026): a tenant whose payouts are held by the EVI platform never holds a Stripe Connect account.
 * GET /admin/tenants/:id/connect/status returns platform_held from the same predicate that makes POST /connect/start answer 409
 * PLATFORM_HELD_TENANT, so the Payouts surfaces hide Start and Continue on that flag alone (strictly true), never on persona. */
export const PLATFORM_HELD_PAYOUTS_COPY = 'Payouts for this tenant are held by the EVI platform. No bank account is connected here.';

export type TenantPayoutsView = 'platform_held' | 'ready' | 'not_started' | 'in_progress';

/** Which Payouts state to render. Without the flag this is the original branching: ready when charges and payouts are both
 * enabled, otherwise not started without an account and in progress with one. */
export function tenantPayoutsView(status: {
  platform_held?: unknown; has_account: boolean; charges_enabled: boolean; payouts_enabled: boolean;
}): TenantPayoutsView {
  if (status.platform_held === true) return 'platform_held';
  if (status.charges_enabled && status.payouts_enabled) return 'ready';
  return status.has_account ? 'in_progress' : 'not_started';
}
